/**
 * home模块接口列表
 */

import axios from '@/api/http'; // 导入http中创建的axios实例
import base from '@/api/base'; // 导入接口域名列表
const home = {
  // 登出  
  loginOut() {
    return axios.post(`${base.baseURL}login/logout`);
  },
  // 修改密码  
  editPassW(oldPassword, newPassword, userId) {
    return axios.put(`${base.baseURL}user/own`, {
      oldPassword,
      newPassword,
      userId
    });
  },
}
export default home;



// WEBPACK FOOTER //
// ./src/network/home.js